
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gfU2_X49u3ASyJ5dUh_vMKBTp_WBanRS5mcqQamK9Q4EMeta } from "/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexAEOt4zJFyx_45RwFOONZ95oehhBKRUvbjoaZNKgldYCh0Meta } from "/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchPmx47RV71AlZ9A_cbgk_cw3SzimL3F9WfVSqBysjPEsMeta } from "/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexACaLbD_B6a2A58zqJHATrE9pOHuxQPkI0egdCV0ek5cMeta } from "/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93VKYf0IfEi5S5d09vUXs5nY_45D77E0zYXAvWe18hP9FykMeta } from "/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexr2Eqim4e50V4zX446WrOxRtjjkUAF88YkFh3zlAHjZYMeta } from "/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93YMR_45I0M3xISFjNyb_Ew2GvVMecsWI4nhoTgkfeWIEJoMeta } from "/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexcpIh6i_8fcGFu9CaiKWU7RjuRXgH6_pNV7_4wU92CPYMeta } from "/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93rEbHOSwZfrVUmq0ATZbjTuuK9suwKW_45b0FOQ2aFFyloMeta } from "/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexg2a_45usUvv5OEtDG0rqzNbdcTMg3NO8ZjboZtETu7J2cMeta } from "/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexCtr1m5yr2ikC0pfK0jgoR43szRvrEGErO4Ttk9ZQBa0Meta } from "/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexr2Eqim4e50V4zX446WrOxRtjjkUAF88YkFh3zlAHjZYMeta || {},
    component: () => import("/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexcpIh6i_8fcGFu9CaiKWU7RjuRXgH6_pNV7_4wU92CPYMeta || {},
    component: () => import("/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexg2a_45usUvv5OEtDG0rqzNbdcTMg3NO8ZjboZtETu7J2cMeta || {},
    component: () => import("/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexCtr1m5yr2ikC0pfK0jgoR43szRvrEGErO4Ttk9ZQBa0Meta || {},
    component: () => import("/codebuild/output/src1841238227/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]